module.exports = __webpack_public_path__ + "img/advice-2.6fbce042.png";